<template>
    <div class="entity-page-component">
        <div class="tool-bar" >
            <div>
                <v-btn  flat icon light :to="backLink" active-class  ><v-icon>arrow_back</v-icon></v-btn>
                <span class="title">{{ $t("message.Back") }}</span>
            </div>
            <div>
                <v-btn flat icon light v-on:click="save"><v-icon>done</v-icon></v-btn>
            </div>
        </div>

        <div class="entity-page" :style="{ 'min-height': computedPageHeight}">
            <div class="header">
               <v-icon large >business</v-icon>
                <div class="fullname" >{{ entityName }}</div> 
            </div>
            <v-tabs slider-color="secondary" class="app-tabs">
                <v-tab ripple>General</v-tab>
                <v-tab-item>
                   <div class="content">
                      <div class="content-left">
                        <v-text-field v-model="entityName" :label="$t('message.Name')"></v-text-field>
                        <draggable group="people" @start="drag=true" @end="drag=false" @update="onUpdate" style="box-shadow: 0 -1px 0 #e0e0e0, 0 0 2px rgba(0,0,0,.12), 0 2px 4px rgba(0,0,0,.24);">
                          <v-layout row wrap  v-for="item in rules" v-bind:key="item.statusId" class="flow"  >
                            <div style="display: flex; flex-basis: 30px">
                              <v-icon style="cursor: grab;" >drag_indicator</v-icon>
                            </div>
                            <v-flex xs3 sm2 v-for="status in item.statuses" v-bind:key="status.ruleId" >
                              <div style="padding: 0px 10px 0px 0px" >
                                <v-select :items="statuses" v-model="status.statusId" item-text="name" item-value="statusId" :label="$t('message.Status')" @click:append-outer="removeDestination(item, status)" :append-outer-icon="status.icon"  ></v-select>
                              </div>
                            </v-flex>
                            <v-flex xs1 sm1>
                              <div style="padding: 8px 10px 0px 0px;" >
                                <v-btn color="lsecondary" flat icon v-on:click="addDestination(item)"  ><v-icon >add_circle</v-icon></v-btn>
                              </div>
                            </v-flex>
                          </v-layout>
                        </draggable>
                        <v-tooltip left slot="activator" v-bind:class="{ hidden: addIsHidden }" >
                          <v-btn color="lsecondary" flat icon  slot="activator" v-on:click="addRule()" ><v-icon >add_circle</v-icon></v-btn>
                          <span>{{ $t('message.AddRule') }}</span> 
                        </v-tooltip>
                      </div>
                    </div>
                </v-tab-item>
            </v-tabs> 
        </div>
        <v-snackbar
            v-model="showmessage"
            bottom="bottom"
            right="right"
            :timeout="6000"
            >
            <span>{{ alertMessage }}</span>
            <v-btn v-on:click="showmessage = false" flat icon dark><v-icon>close</v-icon></v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import GenericRepository from "../../services/GenericRepository.js";
import ProcessRepository from "../../services/ProcessRepository.js";
import draggable from "vuedraggable";
import HAL from "../../helpers/HAL.js";
import { mapGetters } from 'vuex';

export default {
    name: "ProcessFlowPage",
     computed: {
        ...mapGetters([
            'user'
        ]),
        computedPageHeight: function() {
            return this.pageHeight + 'px';
        },
        addIsHidden: function() {
           return this.unassignedRules == undefined || this.unassignedRules.length == 0;
        }
    },
    components: {
      draggable
    },
  data() {
    return {
      pageHeight: 10,
      entityName: "",
      startDate: null,
      dueDate: null,
      processId: null,
      projectId: null,
      updateLink: null,
      insertLink: "/api/process",
      backLink: "/process-list",
      menu: false,
      menuStart: false,
      statuses: [],
      rules: [],
      unassignedRules: [],
      isLoading: false,
      search: null,
      showmessage: false,
      alertMessage: ''
    };
  },
   methods: {
    goBack() {
      return "/process-list";
    },
    onUpdate(event) {
      var item = this.rules.splice(event.oldDraggableIndex, 1);
      this.rules.splice(event.newDraggableIndex, 0, item[0]);
    },
    addDestination(item) {
      item.statuses.push({ statusId: null, showDelete: true, icon: "remove_circle" });
    },
    removeDestination(main, item) {
      if(item.isFirst) {
        let ix = this.rules.indexOf(main);
        let crtItem = this.rules.splice(ix, 1);
        if(crtItem)
          this.unassignedRules.push(crtItem[0]);
      }
      else {
        let crt = main.statuses.indexOf(item);
        if(crt != -1)
          main.statuses.splice(crt, 1);
      }
    },
    addRule() {
      var newStatus = this.unassignedRules.pop();
      var newRule = { statusId: newStatus.statusId,  statuses :[ { statusId: newStatus.statusId, showDelete: true, icon: "remove_circle", isFirst: true }] };
      this.rules.push(newRule);
    },
    buildJson() {
      let entity = {
        processId: this.processId,
        name: this.entityName,
        rules: []
      };
      for(let i in this.rules) {
        let crtRule = { statuses: [], statusId: 0, orderId: i };
        for(let k in this.rules[i].statuses) {
          if(this.rules[i].statuses[k].isFirst)
            crtRule.statusId = this.rules[i].statuses[k].statusId;
          else 
            crtRule.statuses.push({ ruleId: this.rules[i].statuses[k].ruleId, statusId: this.rules[i].statuses[k].statusId });
        }
        entity.rules.push(crtRule)
        
      }
      return entity;
    },
    save() {
      let entity = this.buildJson();
      
      if (entity.processId > 0) {
        GenericRepository.update(this.updateLink.href, entity).then(
          function(response) {
            if (response.data && response.data.status == "Success") {
              window.vm.$router.push(this.goBack());
              this.$emit("save");
            }
            else {
                this.alertMessage = response.data.message;
                this.showmessage = true;
            }
          }.bind(this)
        );
      } else {
        GenericRepository.insert(this.insertLink, entity).then(
          function(response) {
            if (response.data && response.data.status == "Success") {
              window.vm.$router.push(this.goBack());
              this.$emit("save");
            }
            else {
                this.alertMessage = response.data.message;
                this.showmessage = true;
            }
          }.bind(this)
        );
      }
    }
  },
  created() {
    this.pageHeight = window.innerHeight - 57 - 25 - 25;
    
    if (!isNaN(this.$route.params.id)) {
      

      GenericRepository.getCollection('api/statuses')
      .then(response => {
        this.statuses = HAL.getEmbededResources(
          response.data,
          "help:status"
        );
      }).then( () => {
        
        ProcessRepository.getByID(this.$route.params.id).then(
          function(response) {
            
            if (response.data && response.data.status == "Success") {
              
              this.entityName = response.data.name;
              this.processId = response.data.processId;
              this.updateLink = HAL.getLink(response.data, "help:process-update");
              let rr = response.data.rules;
              for(let i in rr) {
                let rri = { statusId: rr[i].statusId, statuses: [ { statusId: rr[i].statusId , showDelete: true, icon: "remove_circle", isFirst: true }] };
                for(let k in rr[i].statuses) {
                  rri.statuses.push({ statusId: rr[i].statuses[k].statusId, ruleId: rr[i].statuses[k].ruleId, showDelete: true, icon: "remove_circle" });
                }
                
                this.rules.push(rri);
              }
              this.unassignedRules = response.data.unassignedRules;
            }
          }.bind(this)
        );
      })
      .finally(() => (this.isLoading = false));
    }
    else {
      
       GenericRepository.getCollection('api/statuses')
        .then(response => {
          this.statuses = HAL.getEmbededResources(
            response.data,
            "help:status"
          );
          for(let i in this.statuses) {
            var crt = { statusId: this.statuses[i].statusId,  statuses :[ { statusId: this.statuses[i].statusId, showDelete: true, icon: "remove_circle", isFirst: true }] };
            this.rules.push(crt);
            
          }
        })
        .finally(() => (this.isLoading = false));
    }
  }
}
</script>

<style>
  .flow.layout.row {
    border-bottom: 1px solid #ccc;
  }
</style>

<style lang="stylus">
@import '../../assets/css/tool-bar.css';
@import '../../assets/css/entity-page.css';
</style>

